export const FORM_FIELD_NAMES = {
  CLIENT_ID: 'clientId',
  IP_ENTRIES_SELECT: 'IPEntriesSelect',
} as const

export const TRANSLATION_KEYS = {
  TOAST_SAVE_SUCCESS: 'IP_JOURNAL_COPY_EDITOR.TOAST.SAVE_SUCCESS',
  TOAST_SAVE_ERROR: 'IP_JOURNAL_COPY_EDITOR.TOAST.SAVE_ERROR',
} as const

export const MODAL_ROLES = {
  CANCEL: 'cancel',
} as const
